import styled from 'styled-components'
import { Link } from 'gatsby'
import Icon from '../icon'
import Text from '../text'

export const StyledText = styled(Text)`
  display: inline;
`

export const Chevron = styled(Icon)`
  margin-right: 6px;
`

export const StyledLink = styled(Link)`
  background: none;
  border: none;
  display: inline-block;
  outline: none;
  padding: 0;
  user-select: none;
  text-decoration: none;

  > * {
    vertical-align: middle;
  }

  > span {
    border-bottom: ${({ underline }) => (underline ? '2px solid' : 'none')};
  }

  &:hover,
  &:active,
  &:focus {
    > span {
      border-bottom: ${({ nohover }) => (nohover ? 'none' : '2px solid')};
    }
  }
`
